import React, { useState, useEffect } from "react";
import {
  Alert,
  Box,
  Button,
  FormControlLabel,
  FormGroup,
  LinearProgress,
  MenuItem,
  Radio,
  Snackbar,
} from "@mui/material";
import YesNoModal from "../Modal/YesNoModal";
import { Formik, Form, Field } from "formik";
import { CheckboxWithLabel, RadioGroup, Select, TextField } from "formik-mui";
import Loading from "../Loading";
import { FieldTypes } from "./fields";
import { FormLabel, Option, Modal } from "react-bootstrap";
import { useLanguage } from "../../Components/Localization/LanguageContext";
import strings from "../../Components/Localization/strings";

import {
  useParams,
  useNavigate,
  useOutletContext,
  useLocation,
  unstable_usePrompt as Prompt,
  unstable_Blocker as useBlocker,
} from "react-router-dom";
import { createField } from "../../api/api";

import * as api from "../../api/api";
import { WindowOutlined } from "@mui/icons-material";
import { cloneDeep } from "lodash";
export default function FieldSection() {
  const { language } = useLanguage();
  const pageTitle = "FieldSection";
  const { id, sectionId } = useParams();
  const [formDirty, setFormDirty] = useState(true);

  const EmptyInitialValues = {
    fieldTypeId: 1,
    formId: Number(id),
    sectionId: sectionId,
    helpText: "",
    isDisabled: false,
    isInfoField: false,
    isIntradayInfoField: false,
    isMemoryField: false,
    isRequired: false,
    isSearchable: false,
    layoutId: 1,
    max: "",
    min: "",
    name: "",
    parentFieldId: null,
    rank: 0,
    serviceId: null,
    sharedKey: "",
    templateFieldId: null,
    tenantId: 1,
    unit: "",
    validationRegEx: "",
    defaultValue: "Default",
    customData: {},
  };
  const navigate = useNavigate();
  const { formsResponse, setFormsResponse, setInactiveForms } =
    useOutletContext();
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [initialValues, setInitialValues] = useState(EmptyInitialValues);
  const [isLoading, setLoading] = useState(false);
  const [possibleParentFields, setPossibleParentFields] = useState([]);
  const [parentValues, setParentValues] = useState({});
  let location = useLocation();

  const [fieldSpecification, setFieldSpecification] = useState({
    type: "",
    values: [
      { _id: 1, name: "single Line Text( 1 Line)" },
      { _id: 2, name: "Text Area(3 Lines)" },
    ],
  });
  const [fieldOptions, setFieldOptions] = useState([{}]);
  const [snackbar, setSnackbar] = useState({
    state: false,
    message: "",
    status: { success: "success", error: "error" },
  });

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setSnackbar({ state: false });
  };
  const params = useParams();
  function handeInitializeField() {
    setParentValues({});
    if (location?.state === null) {
    } else if (location?.state.showDeleteModal === true) {
      setShowDeleteModal(true);
    } else if (location?.state.showDeleteModal === false) {
      setShowDeleteModal(false);
    }

    if (params.fieldId) {
      setLoading(true);
      api.getFieldById(params.fieldId).then((res) => {
        const result = res.data.object;

        let placeholder = {};
        try {
          placeholder = JSON.parse(result.customData);
        } catch (e) {
          console.log(e);
        }
        console.log(placeholder);

        console.log(result);

        if (
          result.parentFieldId !== null &&
          result.parentFieldId !== "null" &&
          result.parentFieldId !== ""
        ) {
          api.getFieldById(result.parentFieldId).then((response) => {
            console.log(response);
            try {
              console.log(JSON.parse(response.data.object.customData));
              let placeholder = JSON.parse(response.data.object.customData);
              setParentValues(placeholder);
              console.log(parentValues, placeholder);
            } catch (e) {
              console.log(e);
              setParentValues(null);
            }
          });
        }

        setInitialValues({
          ...result,
          customData: placeholder,
        });

        try {
          initialValues.customData.values.parentValues.map((value) => {
            console.log("VALUE: ", value);
          });
        } catch (e) {
          console.log(e);
        }

        let newArray = result.fieldType.fieldLayouts.map((fieldLayout) => ({
          _id: fieldLayout.fieldLayoutId,
          name: fieldLayout.description,
        }));
        console.log("new Array: ", newArray);
        setFieldSpecification({ ...fieldSpecification, values: newArray });
        console.log(fieldSpecification);

        if (result.fieldTypeId != 1) {
          api.getFormById(result.formId).then((response) => {
            console.log(response);
            let placeholder = [];

            response.data.object.sections.map((section) => {
              // for each section, check sectionFields
              // if fieldTypeId is 2, push to placeholder
              section.sectionFields.map((field) => {
                // if fieldTypeId is 2, push to placeholder
                if (field.field.fieldTypeId == 2) {
                  // verify that its not itself (do not refer to self in the parent field)
                  if (field.field.fieldId === result.fieldId) {
                    return;
                  }
                  placeholder.push(field);
                  setFieldOptions([{ name: "Values", type: "textbox" }]);
                  setPossibleParentFields(placeholder);
                }
              });
            });
          });
        }

        if (result.fieldTypeId == 7) {
          setLoading(true);
          api
            .getAllServices()
            .then((response) => {
              console.log(response);
              setAllServices(response.data.object);

              let serviceId = parseInt(placeholder.serviceId);

              setAvailableForms(
                response.data.object.filter(
                  (service) => service.serviceId === serviceId
                )[0].offlineForms
              );
            })
            .catch((e) => {
              console.log(e);
            });

          setFieldOptions([
            {
              name: "Service",
              type: "dropdown",
            },
            {
              name: "Form",
              type: "dropdown",
            },
          ]);

          setLoading(false);
        } else if (result.fieldTypeId == 6) {
          setFieldOptions([
            {
              name: "Values",
              type: "textbox",
            },
          ]);
        } else if (result.fieldTypeId == 1 || result.fieldTypeId == 4) {
          console.log("hi");
          console.log("result: ", result);
          setFieldOptions([{ name: "RegEx", type: "textbox" }]);
        }
      });
    } else {
      setInitialValues(EmptyInitialValues);
      setLoading(false);
    }
    console.log(initialValues);
    setLoading(false);
  }
  useEffect(() => {
    setFieldSpecification({
      type: "",
      defaultLayoutId: 1,
      values: [
        { _id: 1, name: "single Line Text( 1 Line)" },
        { _id: 2, name: "Text Area(3 Lines)" },
      ],
    });
    setFieldOptions([{ name: "RegEx", type: "textbox" }]);
    handeInitializeField();
  }, [window.location, params]);

  function handleDeleteModal() {
    api.deleteFieldById(params.fieldId).then(() => {
      navigate("/formsandfields");
      let targetId = parseInt(params.fieldId);
      let newServices = removeTargetField(formsResponse, targetId);
      setFormsResponse(newServices);
      setInactiveForms((prevState) =>
        prevState.map((form) => ({
          ...form,
          sections: form.sections.map((section) => ({
            ...section,
            sectionFields: section.sectionFields.filter(
              (field) => field.fieldId !== targetId
            ),
          })),
        }))
      );
    });
  }

  const [allServices, setAllServices] = useState([]);
  const [availableForms, setAvailableForms] = useState([]);

  function updateFieldNames(services, fieldId, newName) {
    let newServices = cloneDeep(services);
    function updateFields(forms) {
      return forms.map((form) => ({
        ...form,
        sections: form.sections.map((section) => ({
          ...section,
          sectionFields: section.sectionFields.map((field) =>
            field.fieldId === fieldId
              ? { ...field, field: { ...field.field, name: newName } }
              : field
          ),
        })),
      }));
    }

    newServices.forEach((service) => {
      service.callLineForms = updateFields(service.callLineForms);
      service.ddiForms = updateFields(service.ddiForms);
      service.offlineForms = updateFields(service.offlineForms);
      if (service.subServices) {
        updateFieldNames(service.subServices, fieldId, newName);
      }
    });

    return newServices;
  }
  function updateSectionFields(services, sectionId, newField) {
    let newServices = cloneDeep(services);
    function updateFields(forms) {
      return forms.map((form) => ({
        ...form,
        sections: form.sections.map((section) =>
          section.sectionId == sectionId
            ? {
                ...section,
                sectionFields: [
                  ...section.sectionFields,
                  { fieldId: newField.fieldId, field: newField },
                ],
              }
            : section
        ),
      }));
    }

    newServices.forEach((service) => {
      service.callLineForms = updateFields(service.callLineForms);
      service.ddiForms = updateFields(service.ddiForms);
      service.offlineForms = updateFields(service.offlineForms);
      if (service.subServices) {
        updateFieldNames(service.subServices, sectionId, newField);
      }
    });
    console.log("new services in field creation: ", newServices);
    return newServices;
  }

  function removeTargetField(services, fieldId) {
    let newServices = cloneDeep(services);
    function updateFields(forms) {
      return forms.map((form) => ({
        ...form,
        sections: form.sections.map((section) => ({
          ...section,
          sectionFields: section.sectionFields.filter(
            (field) => field.fieldId !== fieldId
          ),
        })),
      }));
    }

    newServices.forEach((service) => {
      service.callLineForms = updateFields(service.callLineForms);
      service.ddiForms = updateFields(service.ddiForms);
      service.offlineForms = updateFields(service.offlineForms);
      if (service.subServices) {
        updateFieldNames(service.subServices, fieldId);
      }
    });

    return newServices;
  }

  return (
    <div className="main-content">
      {isLoading && <Loading />}{" "}
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validate={(values) => {
          let errors = {};

          console.log(values);

          try {
            let arrayOfValues = values.customData.values.split(";");
            let set = new Set(arrayOfValues);
            if (set.size !== arrayOfValues.length) {
              console.log();
              errors = { ...errors, customData: { values: {} } };

              errors.customData.values = "Values must be unique ";

              return errors;
            }
          } catch (e) {
            console.log(e);
          }

          if (values.fieldTypeId == 7) {
            if (
              values.customData.serviceId === undefined ||
              values.customData.formId === undefined
            ) {
              errors = { ...errors, customData: { values: {} } };

              errors.customData.values = "Required";
              return errors;
            }
          } else if (values.fieldTypeId == 6) {
            if (
              values.customData === undefined ||
              values.customData?.values?.length === 0 ||
              values.customData.values === undefined
            ) {
              errors = { ...errors, customData: { values: {} } };

              errors.customData.values = "Required";
              return errors;
            }
          }

          function isValidRegExpString(input) {
            try {
              new RegExp(input);
              return true;
            } catch (error) {
              return false;
            }
          }

          if (!isValidRegExpString(values.validationRegEx)) {
            errors.validationRegEx = "Invalid RegExp";
            return errors;
          }

          if (!values.rank && !values.name) {
            errors.rank = "Required";
            errors.name = "Required";
          } else if (!/^[0-9]\d*$/.test(values.rank)) {
            errors.rank = "Invalid rank number";
          }
          return errors;
        }}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          setFormDirty(false);
          console.log(values);
          console.log(values.customData);
          let placeholder = values.customData;
          placeholder = JSON.stringify(placeholder);

          values = { ...values, customData: placeholder };
          console.log(values);

          if (params.fieldId) {
            api
              .updateField(params.fieldId, values)
              .then((res) => {
                setSnackbar({
                  state: true,
                  message: res.data.message,
                  status: "success",
                });
                setSubmitting(false);
                resetForm();
                console.log(res.data);
                // navigate("/formsandfields/"+params.id + "/section/" + res.data.object.sectionId)
                // handleFetchServices();
                let targetId = parseInt(params.fieldId);
                let newServices = updateFieldNames(
                  formsResponse,
                  targetId,
                  values.name
                );
                setFormsResponse(newServices);
                setInactiveForms((prevState) =>
                  prevState.map((form) => ({
                    ...form,
                    sections: form.sections.map((section) => ({
                      ...section,
                      sectionFields: section.sectionFields.map((field) =>
                        field.fieldId === targetId
                          ? {
                              ...field,
                              field: { ...field.field, name: values.name },
                            }
                          : field
                      ),
                    })),
                  }))
                );
                // handleFetchServicesState()
                handeInitializeField();
              })
              .catch((err) => {
                setSnackbar({
                  state: true,
                  message: err.message,
                  status: "error",
                });
              });
          } else {
            console.log(values);

            console.log(
              api.isFieldNameDuplicatedWithinSection(values.name, sectionId)
            );

            api
              .isFieldNameDuplicatedWithinSection(values.name, sectionId)
              .then((response) => {
                console.log(response);
                if (response.data === true) {
                  setSnackbar({
                    state: true,
                    message: "Field name already exists in this section",
                    status: "error",
                  });
                  setSubmitting(false);
                } else {
                  createField(values)
                    .then((res) => {
                      setSnackbar({
                        state: true,
                        message: res.data.message,
                        status: "success",
                      });
                      resetForm();
                      setSubmitting(false);
                      navigate(
                        "/formsandfields/" +
                          params.id +
                          "/section/" +
                          params.sectionId +
                          "/field/" +
                          res.data.object.fieldId
                      );
                      let targetId = parseInt(values.sectionId);
                      let newServices = updateSectionFields(
                        formsResponse,
                        targetId,
                        res.data.object
                      );
                      setFormsResponse(newServices);
                      setInactiveForms((prevState) =>
                        prevState.map((form) => ({
                          ...form,
                          sections: form.sections.map((section) =>
                            section.sectionId == targetId
                              ? {
                                  ...section,
                                  sectionFields: [
                                    ...section.sectionFields,
                                    {
                                      fieldId: res.data.object.fieldId,
                                      field: res.data.object,
                                    },
                                  ],
                                }
                              : section
                          ),
                        }))
                      );
                    })
                    .catch((err) => {
                      setSnackbar({
                        state: true,
                        message: err.message,
                        status: "error",
                      });
                    });
                }
              })
              .catch((e) => {
                console.log(e);
              });
          }
          setFormDirty(false);
        }}
      >
        {({
          submitForm,
          values,
          setValues,
          isSubmitting,
          resetForm,
          dirty,
        }) => (
          <Form
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              flexWrap: "wrap",
              maxWidth: "70%",
            }}
          >
            <Field
              component={TextField}
              name="name"
              type="Field Name"
              label="Field Name"
              required
            />
            <br />
            <FormLabel>{strings[pageTitle][language].fieldType}</FormLabel>
            <Field component={RadioGroup} column name="fieldTypeId" required>
              {FieldTypes.map((field, i) => (
                <FormControlLabel
                  value={Number(field._id)}
                  control={<Radio disabled={isSubmitting} />}
                  label={field.name}
                  disabled={isSubmitting || params.fieldId}
                  onChange={() => {
                    setParentValues({});
                    values.parentFieldId = null;
                    setFieldSpecification(field.specification);
                    setValues({
                      ...values,
                      fieldTypeId: field._id,
                      layoutId: field.specification.defaultLayoutId,
                    });

                    console.log(field._id);

                    if (field._id == 2) {
                      setLoading(true);
                      api.getFormById(id).then((response) => {
                        console.log(response);

                        let placeholder = [];
                        response.data.object.sections.map((section) => {
                          // for each section, check sectionFields
                          section.sectionFields.map((field) => {
                            // if fieldTypeId is 2, push to placeholder
                            if (field.field.fieldTypeId == 2) {
                              console.log(field);
                              placeholder.push(field);
                            }
                          });
                        });
                        console.log(placeholder);
                        setPossibleParentFields(placeholder);
                        setLoading(false);
                      });
                    } else if (field._id == 7) {
                      console.log(field.options);
                      setLoading(true);

                      // get services, then depending on service get the forms
                      api
                        .getAllServices()
                        .then((response) => {
                          console.log(response);
                          setAllServices(response.data.object);
                          setLoading(false);
                        })
                        .catch((e) => {
                          console.log(e);
                        });
                    } else if (field._id == 5) {
                    } else if (field._id == 1) {
                      console.log(field.options);
                    }

                    setFieldOptions(field.options);
                    console.log(field.options);
                  }}
                />
              ))}
            </Field>
            <br />
            <FormLabel>{strings[pageTitle][language].spec}</FormLabel>
            {fieldSpecification.values && (
              <Field component={RadioGroup} column name="layoutId" required>
                {fieldSpecification.values &&
                  fieldSpecification.values.map((val, i) => (
                    <FormControlLabel
                      value={Number(val._id)}
                      control={<Radio disabled={isSubmitting} />}
                      label={val.name}
                      disabled={isSubmitting}
                    />
                  ))}
              </Field>
            )}
            <br />
            <Field
              component={TextField}
              name="helpText"
              type="text"
              label={strings[pageTitle][language].helpText}
            />
            <br />
            {values.fieldTypeId != 7 && (
              <Field
                component={CheckboxWithLabel}
                type="checkbox"
                name="isRequired"
                Label={{ label: strings[pageTitle][language].required }}
              />
            )}
            <Field
              component={CheckboxWithLabel}
              type="checkbox"
              name="isDisabled"
              Label={{ label: strings[pageTitle][language].inactive }}
            />
            {values.fieldTypeId != 7 && (
              <Field
                component={CheckboxWithLabel}
                type="checkbox"
                name="isMemoryField"
                Label={{ label: strings[pageTitle][language].memory }}
              />
            )}
            {values.fieldTypeId != 7 && (
              <Field
                component={CheckboxWithLabel}
                type="checkbox"
                name="isInfoField"
                Label={{ label: strings[pageTitle][language].displayAgent }}
              />
            )}
            {values.fieldTypeId != 7 && (
              <Field
                component={CheckboxWithLabel}
                type="checkbox"
                name="isIntradayInfoField"
                Label={{ label: strings[pageTitle][language].displayIntra }}
              />
            )}
            <Field
              component={CheckboxWithLabel}
              type="checkbox"
              name="isSearchable"
              Label={{ label: strings[pageTitle][language].search }}
            />
            <br />
            {values.fieldTypeId != 7 && (
              <Field
                component={TextField}
                name="unit"
                type="unit"
                label={strings[pageTitle][language].unit}
              />
            )}
            <br />
            <Field
              component={TextField}
              name="rank"
              label={strings[pageTitle][language].rank}
              type="text"
            />
            <br />
            {values.fieldTypeId == 2 ? (
              <>
                <Field
                  component={Select}
                  name="parentFieldId"
                  label={strings[pageTitle][language].parent}
                  value={
                    values.parentFieldId == null ? 0 : values.parentFieldId
                  }
                  defaultValue={0}
                  onChange={(e) => {
                    setLoading(true);

                    console.log("Selected value:", e.target.value);

                    if (e.target.value != "null" || e.target.value != 0) {
                      setValues({
                        ...values,
                        parentFieldId: e.target.value,
                      });
                      api.getFieldById(e.target.value).then((response) => {
                        console.log(response);
                        try {
                          console.log(
                            JSON.parse(response.data.object.customData)
                          );
                          let placeholder = JSON.parse(
                            response.data.object.customData
                          );
                          setParentValues(placeholder);
                          console.log(parentValues, placeholder);
                        } catch (e) {
                          console.log(e);
                          setParentValues(null);
                        }
                      });
                    } else {
                      setValues({
                        ...values,
                        parentFieldId: null,
                        customData: "",
                      });

                      console.log({
                        ...values,
                        parentFieldId: null,
                        customData: "",
                      });
                    }
                    setLoading(false);
                  }}
                >
                  <MenuItem value={0}>
                    {strings[pageTitle][language].notSelected}
                  </MenuItem>
                  {possibleParentFields &&
                    possibleParentFields.map((field) => {
                      return (
                        <MenuItem
                          value={parseInt(field.fieldId)}
                          disabled={false}
                          key={field.fieldId}
                        >
                          {field.field.name}
                        </MenuItem>
                      );
                    })}
                </Field>
                <br />
              </>
            ) : (
              ""
            )}

            {parentValues?.parentValues &&
              parentValues?.parentValues.length > 0 &&
              values.parentFieldId != null &&
              values.parentFieldId != "null" &&
              parentValues.parentValues.map((value, itemIndex) => {
                if (value.name == null) return null;
                return value.values.split(";").map((value) => {
                  console.log(value);
                  return (
                    <>
                      <Field
                        component={TextField}
                        name={`customData.parentValues.${value}.value`}
                        label={"'" + value + "' values"}
                        required
                        value={
                          values.customData.parentValues?.filter(
                            (obj) => obj.name == value
                          )[0]?.values
                            ? values.customData.parentValues.filter(
                                (obj) => obj.name == value
                              )[0].values
                            : ""
                        }
                        onChange={(e) => {
                          if (values.customData.parentValues) {
                            console.log(value);
                            console.log(values.customData.parentValues);
                            const filteredArray =
                              values.customData.parentValues.filter(
                                (obj) => obj.name != value
                              );

                            console.log(filteredArray);

                            setValues({
                              ...values,
                              customData: {
                                parentValues: [
                                  ...filteredArray,
                                  {
                                    name: value,
                                    values: e.target.value,
                                  },
                                ],
                              },
                            });
                            console.log(values);
                          } else {
                            setValues({
                              ...values,
                              customData: {
                                parentValues: [
                                  {
                                    name: value.values,
                                    values: e.target.value,
                                  },
                                ],
                              },
                            });
                            console.log(values);
                          }
                        }}
                      />
                      <br></br>
                    </>
                  );
                });
              })}

            {parentValues?.values &&
              parentValues?.values.length > 0 &&
              values.parentFieldId !== null &&
              values.parentFieldId !== "null" &&
              parentValues.values.split(";").map((item, index) => {
                console.log(values.customData.parentValues);
                try {
                  const itemIndex = values.customData.parentValues.findIndex(
                    (obj) => obj.name === item
                  );

                  return (
                    <>
                      <Field
                        component={TextField}
                        name={`customData.parentValues.${item}.value`}
                        label={"'" + item + "' values"}
                        required
                        value={
                          itemIndex !== -1
                            ? values.customData?.parentValues[itemIndex].values
                            : ""
                        }
                        onChange={(e) => {
                          if (values.customData.parentValues) {
                            const filteredArray =
                              values.customData.parentValues.filter(
                                (obj) => obj.name != item
                              );

                            setValues({
                              ...values,
                              customData: {
                                parentValues: [
                                  ...filteredArray,
                                  { name: item, values: e.target.value },
                                ],
                              },
                            });
                            console.log(values);
                          } else {
                            setValues({
                              ...values,
                              customData: {
                                parentValues: [
                                  { name: item, values: e.target.value },
                                ],
                              },
                            });
                            console.log(values);
                          }
                        }}
                      />
                      <br></br>
                    </>
                  );
                } catch (e) {
                  return (
                    <>
                      <Field
                        component={TextField}
                        name={`customData.parentValues.${item}.value`}
                        label={"'" + item + "' values"}
                        required
                        onChange={(e) => {
                          if (values.customData.parentValues) {
                            const filteredArray =
                              values.customData.parentValues.filter(
                                (obj) => obj.name != item
                              );

                            setValues({
                              ...values,
                              customData: {
                                parentValues: [
                                  ...filteredArray,
                                  { name: item, values: e.target.value },
                                ],
                              },
                            });
                            console.log(values);
                          } else {
                            setValues({
                              ...values,
                              customData: {
                                parentValues: [
                                  { name: item, values: e.target.value },
                                ],
                              },
                            });
                            console.log(values);
                          }
                        }}
                      />
                      <br></br>
                    </>
                  );
                }
              })}

            {parentValues === null &&
              values.customData.values &&
              !values.customData.values.parentValues &&
              fieldOptions?.map((fieldOption) => {
                if (fieldOption.type === "textbox" && values.fieldTypeId == 2) {
                  //TODO: MIGHT NEED TO DELETE ALL THIS BLOCK AS I ALREADY HANDLED IT BELOW STARTING LINE 640
                  return (
                    <>
                      <Field
                        component={TextField}
                        name="customData.values"
                        type={fieldOption.name}
                        label={"Values"}
                        required
                      />
                    </>
                  );
                }
              })}

            {(values.parentFieldId === null ||
              values.parentFieldId === "null" ||
              values.parentFieldId == 0) &&
              fieldOptions?.map((fieldOption) => {
                if (
                  fieldOption.type === "textbox" &&
                  (values.fieldTypeId == 2 || values.fieldTypeId == 6)
                ) {
                  return (
                    <>
                      <Field
                        component={TextField}
                        name="customData.values"
                        type={fieldOption.name}
                        label={"Values"}
                        required
                        value={
                          values.customData.values
                            ? values.customData.values
                            : ""
                        }
                      />
                      <br></br>
                    </>
                  );
                } else if (
                  fieldOption.type === "dropdown" &&
                  fieldOption.name === "Service"
                ) {
                  return (
                    <>
                      <Field
                        component={Select}
                        type={fieldOption.name}
                        label={fieldOption.name}
                        value={parseInt(values.customData.serviceId)}
                        name={"customData.serviceId"}
                        required
                        onChange={(e) => {
                          console.log(e.target.value);

                          setValues({
                            ...values,
                            customData: {
                              ...values.customData,
                              serviceId: parseInt(e.target.value),
                            },
                          });

                          api
                            .getServiceById(e.target.value)
                            .then((response) => {
                              console.log(response.data.object);
                              setAvailableForms(
                                response.data.object.offlineForms
                              );
                            });
                        }}
                      >
                        {allServices.map((service) => {
                          return (
                            <MenuItem value={service.serviceId}>
                              {service.name}
                            </MenuItem>
                          );
                        })}
                      </Field>
                      <br></br>
                    </>
                  );
                } else if (
                  fieldOption.type === "dropdown" &&
                  fieldOption.name === "Form"
                ) {
                  return (
                    <>
                      <Field
                        component={Select}
                        type={fieldOption.name}
                        label={fieldOption.name}
                        value={parseInt(values.customData.formId)}
                        name={"customData.formId"}
                        required
                        onChange={(e) => {
                          console.log(e.target.value);

                          setValues({
                            ...values,
                            customData: {
                              ...values.customData,
                              formId: parseInt(e.target.value),
                            },
                          });
                        }}
                      >
                        {availableForms &&
                          availableForms.map((form) => {
                            return (
                              <MenuItem value={form.formId}>
                                {form.formName}
                              </MenuItem>
                            );
                          })}
                      </Field>
                      <br></br>
                    </>
                  );
                } else if (
                  fieldOption.type == "textbox" &&
                  fieldOption.name == "RegEx"
                ) {
                  return (
                    <Field
                      component={TextField}
                      name="validationRegEx"
                      type={fieldOption.type}
                      label={"RegEx"}
                      required
                      value={values.validationRegEx}
                    />
                  );
                }
              })}

            {values.customData !== "Custom Data" &&
              values?.customData?.values?.parentValues &&
              values.customData.values.parentValues.map(
                (parentValue, index) => {
                  console.log(parentValue);
                  return (
                    <>
                      <Field
                        component={TextField}
                        name={parentValue.name}
                        label={"'" + parentValue.name + "' values"}
                        required
                        onChange={(e) => {
                          let parentValueName = parentValue.name;
                          let newValue = e.target.value;

                          function editAndFilterArray(
                            parentValues,
                            targetName,
                            newValue
                          ) {
                            // Filter the array to find the object with the given name
                            const targetObject =
                              values.customData.values.parentValues.find(
                                (obj) => obj.name === targetName
                              );

                            // If the object with the target name is found, edit its values
                            if (targetObject) {
                              targetObject.values = newValue;
                            }

                            // Return the modified array
                            return parentValues;
                          }

                          let newArr = editAndFilterArray(
                            values.customData.parentValues,
                            parentValueName,
                            newValue
                          );

                          setValues({
                            ...values,
                            customData: {
                              ...values.customData,
                              parentValues: newArr,
                            },
                          });
                          console.log(values);
                        }}
                        defaultValue={parentValue.values}
                      />
                      <br></br>
                    </>
                  );
                }
              )}
            {isSubmitting && <LinearProgress />}
            <br />
            <Box style={{ display: "flex ", justifyContent: "end" }}>
              {params.fieldId ? (
                <button
                  className="button-round danger"
                  style={{ alignSelf: "flex-end", margin: "1em" }}
                  onClick={(e) => {
                    e.preventDefault();
                    setShowDeleteModal(true);
                  }}
                >
                  {strings[pageTitle][language].delete}
                </button>
              ) : (
                ""
              )}
              <button
                className="button-round cancel"
                style={{ alignSelf: "flex-end", margin: "1em" }}
                onClick={(e) => {
                  e.preventDefault();
                  setShowCancelModal(true);
                }}
              >
                {strings[pageTitle][language].cancel}
              </button>
              <button
                className="button-round"
                style={{ alignSelf: "flex-end", margin: "1em" }}
                disabled={isSubmitting}
                onClick={submitForm}
              >
                {strings[pageTitle][language].save}
              </button>
            </Box>
            <YesNoModal
              propShow={showDeleteModal}
              handleYes={handleDeleteModal}
              handleShowModal={() => {
                setShowDeleteModal(false);
                resetForm();
              }}
            >
              {strings[pageTitle][language].deleteConfirmation}
            </YesNoModal>
            <YesNoModal
              propShow={showCancelModal}
              handleYes={handeInitializeField}
              handleShowModal={() => {
                setShowCancelModal(false);
                resetForm();
              }}
            >
              {strings[pageTitle][language].resetConfirmation}
            </YesNoModal>
            <Prompt
              when={dirty && !isSubmitting && !showDeleteModal}
              message={strings[pageTitle][language].promptMessage}
              beforeUnload={true}
            />
            <br />
          </Form>
        )}
      </Formik>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={snackbar.state}
        autoHideDuration={5000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.status}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
}
